const userMenu = () => {
  document.addEventListener('DOMContentLoaded', function () {

    const userMenuBtn = document.querySelector('.learndash-wrapper .ld-focus-header .user .user-logged-in');
    const userMenuBlock = document.querySelector('.learndash-wrapper .ld-focus-header .user .user-logged-in .woocommerce-MyAccount-navigation');

    if (!userMenuBtn || !userMenuBlock) return;

    let isActive = false;

    const openHandler = (e) => {
      e.stopPropagation();
      userMenuBlock.classList.toggle('show-menu');
    };

    const outsideClickHandler = (e) => {
      if (!userMenuBtn.contains(e.target)) {
        userMenuBlock.classList.remove('show-menu');
      }
    };

    const checkScreenSize = () => {
      if (window.innerWidth < 992 && !isActive) {

        userMenuBtn.addEventListener('click', openHandler);
        document.addEventListener('click', outsideClickHandler);
        isActive = true;
      } else if (window.innerWidth >= 992 && isActive) {

        userMenuBtn.removeEventListener('click', openHandler);
        document.removeEventListener('click', outsideClickHandler);
        userMenuBlock.classList.remove('show-menu');
        isActive = false;
      }
    };

    checkScreenSize();

    window.addEventListener('resize', checkScreenSize);
  });
};

export default userMenu;